module.exports = __webpack_public_path__ + "img/yzr_1_yzr112m_s3.prt.6705f7b7.jpg";